<template>
  <v-app width='100%'>
    <!-- <p>{{GET_AFTE_SEND_FORM }}</p> -->
    <v-main :class="`${GET_PARTNER_DATA.PartnerBackground}  d-flex align-center `">
      <div v-if="!GET_ERROR && !GET_LOAD">
        <v-container>

          <!-- После отправки формы -->
          <div
            v-if="GET_AFTE_SEND_FORM"
            class="text-center white"
          >

            <h3 class="black--text text-center">
              Дякуємо, {{GET_CLINT_BITRIX_DATA.name}} ! Форма надіслана успішно 🏆

            </h3>

            <div v-if="!GET_IS_FOR_PARTNERS">
              <br>
              Щоб ви могли отримати інформацію щодо всіх статусів оформлення - перейдіть в ваш особистий Viber чат, натиснувши кнопку
              <v-btn
                large
                rounded
                color="purple"
                class="white--text text-center go-to-viber"
                :href="`viber://pa?chatURI=teealinfo&context=c${clintBitrixId}`"
              >Перейти у Viber <v-icon
                  class="iconViber"
                  dark
                >mdi-comment-arrow-right</v-icon>
              </v-btn>
            </div>

          </div>

          <!-- //После отправки формы -->
          <v-expand-transition>
            <div v-if="!GET_CLINT_BITRIX_DATA.redy && !GET_AFTE_SEND_FORM && !GET_HIDE_HEAD">
              <div
                v-if="haveClintId"
                class="white"
              >
                <h3 class="black--text text-center">{{GET_CLINT_BITRIX_DATA.hello}}, {{GET_CLINT_BITRIX_DATA.name}}!
                  Це ваша особиста анкета для оформлення та працевлаштування в Польщі.
                  Будь ласка, заповніть усі поля.</h3>
              </div>
            </div>

          </v-expand-transition>

          <div v-if="GET_CLINT_BITRIX_DATA.redy">
            <div
              v-if="haveClintId"
              class="text-center white"
            >
              <h3 class="black--text text-center">{{GET_CLINT_BITRIX_DATA.hello}}, {{GET_CLINT_BITRIX_DATA.name}}!
                Ви вже заповнили форму, дякуємо! )
              </h3>

              <div v-if="!GET_IS_FOR_PARTNERS">
                <h3>Натисніть кнопку нижче, щоб перейти в чат з вашим особистим фахівцем</h3>
                <v-btn
                  large
                  rounded
                  color="purple"
                  class="white--text text-center go-to-viber"
                  :href="`viber://pa?chatURI=teealinfo&context=c${clintBitrixId}`"
                >
                  Перейти у Viber <v-icon
                    class="iconViber"
                    dark
                  >mdi-comment-arrow-right</v-icon>
                </v-btn>
              </div>

            </div>
          </div>

        </v-container>
        <!-- анкета -->
        <div
          class="d-flex  justify-center"
          v-if="!GET_CLINT_BITRIX_DATA.redy && !isCreateClint && !GET_AFTE_SEND_FORM && !GET_LOAD"
        >
          <v-col
            cols="12"
            sm="10"
            md="7"
          >
            <router-view />
            <!-- <router-view @redyForm="AfteSendForm" /> -->
            <!-- <Anketa v-on:redyForm="AfteSendForm"></Anketa> -->

          </v-col>
        </div>

        <!-- //анкета -->
      </div>

      <!-- регистрация -->
      <v-row
        justify="center"
        v-if="!GET_LOAD &&!GET_ERROR"
      >
        <v-dialog
          v-model="isCreateClint"
          persistent
          max-width="600px"
        >

          <v-card>
            <h3 class=" text-center head-registr">

              Анкета для оформлення візи та працевлаштування в Польщі</h3>

            <h4
              class=" text-center head-registr"
              v-if="!redyInputPasport"
            >Будь ласка введить серію і номер закордонного паспорта</h4>

            <v-card-text>
              <v-container>
                <v-form
                  v-model="isValidFerst"
                  v-on:submit.prevent="createClint"
                >
                  <v-row>

                    <v-col cols="10">
                      <!--  :value="newClintPasport" -->
                      <v-text-field
                        v-model="newClintPasport"
                        name="pasport"
                        type="text"
                        label="Серія і номер закордонного паспорта*"
                        hint="AE123456"
                        :rules="[v => (v && v.replace(/[^A-Za-z0-9]/g, '').length >7)|| 'Лише латинські букви, та цифри']"
                        required
                        @input="inputPasport"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="2"
                      class="d-flex align-center"
                    >
                      <v-icon
                        v-if="redyInputPhone"
                        large
                        color="green"
                      >mdi-check-circle-outline</v-icon>

                    </v-col>
                    <v-col
                      cols="12"
                      v-if="isAskName"
                    >
                      <v-text-field
                        v-model="newClintLastName"
                        label="Ваше прізвище як в закордонному паспорті"
                        hint="SHEVCHENKO"
                        required
                        :rules="[v => !!v || 'Це обов\'язкове поле']"
                      ></v-text-field>

                      <v-text-field
                        v-model="newClintName"
                        label="Ваше ім'я як в закордонному паспорті"
                        hint="TARAS"
                        required
                        :rules="[v => !!v || 'Це обов\'язкове поле']"
                      ></v-text-field>

                    </v-col>

                  </v-row>
                </v-form>
              </v-container>
              <!-- <small>*indicates required field</small> -->
            </v-card-text>
            <v-card-actions>

              <v-btn
                color="error"
                text
                @click="clear"
              >Відміна</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                large
                class="white--text"
                color="teal "
                :disabled="!isValidFerst"
                @click="createClint"
              >Далі</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- //регистрация -->

      <!-- ошибка -->

      <div
        v-if="GET_ERROR"
        class="white"
      >
        <h3 class="black--text text-center">Помилка "{{GET_ERROR}}". Будь ласка спробуйте зайти пізніше, або зверніться до вашого фахівця</h3>

      </div>

      <!-- Лого ТЕЕАЛ -->
      <div
        class="d-flex  justify-center logoTEEAL align-start "
        v-if="!GET_IS_FOR_PARTNERS"
      >
        <v-img
          class="logo-partner"
          max-width="40"
          src='/../logo.png'
        ></v-img>
        <span class="white--text desTEEAL">Designed for TEEAL</span>
      </div>
      <div class="d-flex  justify-center  white--text  logoTEEAL">

      </div>

      <!-- /Лого ТЕЕАЛ -->

      <!-- лого -->
      <div
        class="d-flex  justify-center white logoTEEAL align-start "
        v-if="GET_IS_FOR_PARTNERS"
      >
        <span class="black--text desTEEAL">{{GET_PARTNER_DATA.PartnerBrand}}</span>
      </div>
      <div class="d-flex  justify-center  white--text  logoTEEAL">
      </div>

      <!-- лого -->

      <v-overlay v-if="GET_LOAD">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

    </v-main>
  </v-app>
</template>

<script>
import Anketa from "./components/Anketa";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "App",

  // components: {
  //   Anketa
  // },
  data() {
    return {
      managerId: null,
      //newDealId: null,
      haveClintId: false,
      clintBitrixId: null,
      isCreateClint: false,
      newClintPasport: "",
      newClintLastName: null,
      newClintName: null,
      isAskName: false,
      redyInputPhone: false,
      isValidFerst: true,
      isAfteSendForm: false,
    };
  },

  mounted() {
    const query = this.$route.query;
    // console.log(this.$route);
    if (query.id) {
      //ссылка содержит айди клиента
      //если есть ?id={id}
      this.UPDATE_CLINT_BITRIX_DATA(query.id);
      let clintIdS = { clinBitrixID: query.id };
      this.SAVE_CLINT_BITRIX_ID(clintIdS);
      this.haveClintId = true;
      this.clintBitrixId = query.id;
      //  console.log(query.id);
    } else if (query.managerid) {
      // ссылка содержит айди менеджера
      this.isCreateClint = true;
      this.managerId = query.managerid;

      this.GET_PARTNER_INFO(query.managerid);
      //если есть ?managerid={managerid}
      //  console.log(query.managerid);
    } else {
      this.CREATE_ERROR("не знайдено ID кліента"); //екшин отправляю ошибку
    }
  },
  methods: {
    ...mapActions([
      "UPDATE_CLINT_BITRIX_DATA", // получает данные оклиенте по айди
      "SEARCH_BITRIX_CLINT", // ищет клиента по номеру телефона
      "CREATE_CLINT", // создает клиента
      "SAVE_CLINT_BITRIX_ID", //записывает айди клиента в стор
      "CREATE_ERROR", // создает ошибку
      "GET_PARTNER_INFO",
    ]),

    // pasportUserInput(input) {
    //   //const regex2 = new RegExp("[a-z0-9]+$", "gi");

    //   //  let vvod = input.match(/[a-z0-9]/gi);

    //   //  let vvod = input.replace(/[^a-z+$0-9+$]/gi, "");

    //   //input.match(regex2).join("").toUpperCase();

    //   // vvod.join("").toUpperCase();

    //   // console.log(vvod);
    //   // input.replace(/[^A-Za-z0-9]/g, "");

    // //  this.newClintPasport = "1";
    //   //this.newClintPasport = vvod;

    //   //.toUpperCase();
    // },

    inputPasport() {
      //     this.newClintPasport = "1";

      this.newClintPasport = this.newClintPasport
        .toUpperCase()
        .replace(/[^A-Za-z0-9]/g, "");

      //поиск клиента по номеру телефона
      let pasport = this.newClintPasport;
      console.log(pasport);
      if (pasport.length >= 8) {
        //когда ввел больше 10 символов
        if (
          pasport.length == 8
          // || (phone[0] == 8 && phone.length == 11) ||
          // (phone[0] == 0 && phone.length == 10)
        ) {
          this.redyInputPasport = true;

          this.SEARCH_BITRIX_CLINT(pasport).then((clintData) => {
            if (clintData.status == "emptyContact") {
              this.isAskName = true;
            } else if (clintData.status == "true") {
              if (this.managerId) {
                if (this.managerId !== clintData.managerID) {
                  //this.managerId - менеджер че айди в ссылке
                  //clintData.managerID - менеджер чье айди в битриксе
                  const massageWarn = `Конфликт по клиенту ${clintData.name} ${clintData.LastName} https://teeal.bitrix24.ua/crm/contact/details/${clintData.clintID}/ `;
                  //несовпадают айди созданого клиента
                  axios.get(
                    `https://partners-sender.fenek.fun/senderViber.php?managerId=${this.managerId}&massage=${massageWarn} по вашей анкете обратился клиент другой компании`
                  );
                  axios.get(
                    `https://partners-sender.fenek.fun/senderViber.php?managerId=${clintData.managerID}&massage=${massageWarn} ваш клиент обратился по чужой анкете`
                  );

                  console.log("warning");
                }
              }
              this.redirectToPersonalForm(clintData.clintID);
            }
          });
          // console.log(phone);
        } else if (pasport.length >= 7) {
          // this.isAskName = true;
        }
      }
    },
    createClint() {
      if (this.newClintPasport.replace(/[^A-Za-z0-9]/g, "").length > 7) {
        if (!this.newClintName) {
          // через екшин - ищет клиента и возвращет - есть такой или нет
          this.SEARCH_BITRIX_CLINT(this.newClintPasport).then((clintData) => {
            if (clintData.status == "emptyContact") {
              this.isAskName = true;
            } else if (clintData.status == "true") {
              if (this.managerId) {
                if (this.managerId !== clintData.managerID) {
                  //this.managerId - менеджер че айди в ссылке
                  //clintData.managerID - менеджер чье айди в битриксе
                  const massageWarn = `Конфликт по клиенту ${clintData.name} ${clintData.LastName} https://teeal.bitrix24.ua/crm/contact/details/${clintData.clintID}/ `;
                  //несовпадают айди созданого клиента
                  axios.get(
                    `http://partners-sender.fenek.fun/senderViber.php?managerId=${this.managerId}&massage=${massageWarn} по вашей анкете обратился клиент другой компании`
                  );
                  axios.get(
                    `http://partners-sender.fenek.fun/senderViber.php?managerId=${clintData.managerID}&massage=${massageWarn} ваш клиент обратился по чужой анкете`
                  );

                  console.log("warning");
                }
              }
              //console.log(clintData);
              this.redirectToPersonalForm(clintData.clintID);
            } else {
              this.isCreateClint = false;
              this.CREATE_ERROR(
                "Помилка, з'єднання з сервером, будь ласка перезавантажте сторінку"
              );
            }
          });
        }

        //создаю клиента по менеджером
        if (
          this.newClintPasport &&
          this.newClintName &&
          this.newClintLastName
        ) {
          const datanewClint = JSON.stringify({
            pasport: this.newClintPasport,
            name: this.newClintName,
            lastNameCont: this.newClintLastName,
            managerID: this.managerId,
            brand: this.GET_PARTNER_DATA.PartnerBrand,
            isPartner: this.GET_IS_FOR_PARTNERS,
          });

          this.CREATE_CLINT(datanewClint).then((newClint) => {
            // this.newDealId = newClint.deal;
            this.redirectToPersonalForm(newClint.clintID, newClint.deal);
          });
        } else {
          this.isAskName = true;
        }
      }
    },
    clear() {
      this.newClintPasport = "";
    },

    redirectToPersonalForm(clintID, dealID) {
      this.UPDATE_CLINT_BITRIX_DATA(clintID);

      let clintIdS = { clinBitrixID: clintID, clinDealID: dealID };

      this.SAVE_CLINT_BITRIX_ID(clintIdS);
      this.$router.push(`?id=${clintID}`);
      this.isAskName = false;
      this.haveClintId = true;
      this.isCreateClint = false;
      this.clintBitrixId = clintID;
    },
    AfteSendForm(clintID) {
      //  console.log("AfteSendForm");
      this.clintBitrixId = clintID;
      this.haveClintId = false;
      this.isAfteSendForm = true;
    },
  },

  computed: {
    ...mapGetters([
      "GET_CLINT_BITRIX_DATA",
      "GET_ERROR",
      "GET_CLINT_BITRIX_ID",
      "GET_LOAD",
      "GET_AFTE_SEND_FORM",
      "GET_HIDE_HEAD",
      "GET_PARTNER_DATA",
      "GET_IS_FOR_PARTNERS",
    ]),

    // vvod: function () {
    //   return this.newClintPasport + "2";
    // },

    // newClintPasport2: {
    //   return: "5",
    // },
  },
};
</script>

<style scoped>
.go-to-viber {
  margin: 40px 0;
}
.go-to-viber a {
  text-decoration: none;
}

.iconViber {
  margin: 10px;
}

.head-registr {
  padding: 15px;
  font-weight: 400;
}

.logoTEEAL {
  margin-top: 25px;
}

.desTEEAL {
  margin: 8px;
}
</style>
